<script setup>
import {ref, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import DashboardActivityStreamItem from './DashboardActivityStreamItem'
import api from '@/services/api'

const itemDataStore = useItemDataStore()

const items = ref([])
const userId = ref(0)

const setUserId = (id) => {
    userId.value = id
}

const getUserId = () => userId.value

const fetchActivity = async () => {
    try {
        const response = await api.get('api/component/activity/id', {
            params: {
                createdBy: {gt: 0},
                sort: '-id',
                limit: 10
            }
        })

        const ids = response.data.values

        if (ids && ids.length > 0) {
            items.value = await itemDataStore.preload({
                tableName: 'activity',
                ids
            })
        }
    } catch (error) {
        console.error("Failed to load activity stream:", error)
    }
}

watch(() => true, fetchActivity, {immediate: true})
</script>

<template>
    <div class="card dashboard-panel-activity-stream">
        <div class="card-header">
            Activity stream
        </div>

        <div class="card-body pt-0">
            <DashboardActivityStreamItem
                v-for="item in items"
                :key="item.id"
                :get-user-id="getUserId"
                :item="item"
                :set-user-id="setUserId"
            />
        </div>
    </div>
</template>

<style scoped>
.card-body {
    height: 405px;
    overflow: scroll;
}
</style>